import { useMutation } from '@tanstack/react-query';
import { api } from '@/api';
import { queryClient } from '@/queries';
import { hospitalContactsQueries } from '@/queries/hospital-contacts';
import { NewHospitalContactFormBody, PatchHospitalContactFormBody } from '@/api/apis/facilities';
import { hospitalContactsQueryKeys } from './hospital-contacts.keys';

export const useCreateHospitalContactMutation = () => {
  return useMutation({
    mutationFn: ({ parentId, ...variables }: NewHospitalContactFormBody & { parentId: string }) =>
      api.hospital.createHospitalContact(parentId, variables),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: hospitalContactsQueryKeys.getList(), exact: false });
      queryClient.setQueryData(hospitalContactsQueries.item(data.id).queryKey, data);
    },
  });
};

export const useUpdateHospitalContactMutation = () => {
  return useMutation({
    mutationFn: (variables: PatchHospitalContactFormBody & { id: string }) =>
      api.hospital.updateHospitalContact(variables),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: hospitalContactsQueryKeys.getList(), exact: false });
      queryClient.resetQueries({ queryKey: hospitalContactsQueries.item(variables.id).queryKey });
    },
  });
};
